import { db } from '../firebase.js'
import { doc, collection, getDoc } from "firebase/firestore";
import { useParams } from 'react-router';
import $ from 'jquery'; 
import { useEffect, useState} from 'react';
import { Component } from 'react';
import React from 'react';

import { useNavigate } from 'react-router-dom'; 

// shopik.io itself (plus its Firebase-hosted staging/preview domains) uses this app's
// root as a bounce back to the marketing site — the real landing page lives on
// shopik-next-webapp, and only specific paths (/login, /products, etc.) come here.
// A white-labeled custom domain (e.g. dashboard.hemlockapp.com) has no separate
// marketing site pointed at it, so root should land in the dashboard itself.
function isKnownShopikHost(host) {
  return (
    host.endsWith('shopik.io') ||
    host.endsWith('.web.app') ||
    host.endsWith('.firebaseapp.com') ||
    host === 'localhost'
  );
}

export default function HomeRedirect() {
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    if (isKnownShopikHost(window.location.hostname)) {
      window.location.replace('https://shopik.io');
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  // Return null to prevent rendering anything for this component
  return null;
}

